import React, { FC } from "react";

export const LeftAngleIcon: FC = () => {
    return (
        <svg viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 14L3 7.5L10 1" stroke="currentColor" fill="none" strokeLinecap="square" />
        </svg>
    );
}